export default "__VITE_ASSET__QCuLsnWc__"